import type { Submission } from "@/api/submissions.service.js";
import type { SubmissionWithTranslations } from "@/hooks/useTranslations.js";

function formatPracticeParts(parts: string[]): string {
  const dedupedParts: string[] = [];
  for (const part of parts) {
    if (dedupedParts.length === 0 || dedupedParts[dedupedParts.length - 1] !== part) {
      dedupedParts.push(part);
    }
  }

  if (dedupedParts.length === 0) {
    return "-";
  }
  if (dedupedParts.length === 1) {
    return dedupedParts[0];
  }
  return dedupedParts.join(" > ");
}

export function getSubmissionPracticeFullName(submission: Submission): string {
  const parts: string[] = [];

  if (submission.practiceGroupName) {
    parts.push(submission.practiceGroupName);
  }
  if (submission.practiceAreaName) {
    parts.push(submission.practiceAreaName);
  }
  if (submission.tableName) {
    parts.push(submission.tableName);
  }

  return formatPracticeParts(parts);
}

export function getSubmissionPracticeFullNameTranslated(
  submission: SubmissionWithTranslations,
): string {
  const parts: string[] = [];

  const practiceGroupName = submission.practiceGroupTranslated || submission.practiceGroupName;
  const practiceAreaName = submission.practiceAreaTranslated || submission.practiceAreaName;
  const tableName = submission.tableTranslated || submission.tableName;

  if (practiceGroupName) {
    parts.push(practiceGroupName);
  }
  if (practiceAreaName) {
    parts.push(practiceAreaName);
  }
  if (tableName) {
    parts.push(tableName);
  }

  return formatPracticeParts(parts);
}
